import { appConfig } from '../../content/ja';

export function initAppLinks(): void {
  const openAppBtn = document.getElementById('open-app-btn');
  const openAppBtnSticky = document.getElementById('open-app-btn-sticky');
  const openAppStep1 = document.getElementById('open-app-step1');

  if (openAppBtn) {
    openAppBtn.setAttribute('href', appConfig.liffUrl);
  }

  if (openAppBtnSticky) {
    openAppBtnSticky.setAttribute('href', appConfig.liffUrl);
  }

  if (openAppStep1) {
    openAppStep1.setAttribute('href', appConfig.liffUrl);
  }
}
